import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import styles from './TransitTab.module.scss'
import DocTable from '../../components/DocTable/DocTable'
import SearchBar from '../../components/SearchBar/SearchBar'
import { getTransitDocuments, downloadDocument } from 'service/KomurConnectionService'
import { filterDocs } from '../../utils'

export default function TransitTab({ onPreview }) {
  useInterfaceLanguage();
  const [docs,   setDocs]   = useState(null)
  const [search, setSearch] = useState('')

  useEffect(() => {
    getTransitDocuments()
      .then(r => setDocs(r.data))
      .catch(() => setDocs([]))
  }, [])

  const handleDownload = (_docType, id, fileName) => {
    downloadDocument(id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = fileName || 'document'
      a.click()
    }).catch(() => {})
  }

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{tr("Транзит — общие документы")}</h3>
      <SearchBar value={search} onChange={setSearch} placeholder={tr("Поиск по документам…")} />
      <DocTable
        docs={filterDocs(docs, search)}
        showOwner
        onDownload={handleDownload}
        onPreview={onPreview}
      />
    </div>
  )
}
